<div id="preloaderLogo" class="preloaderLogo" *ngIf="loading$ | async">
  <div class="preloader-content">
    <img src="assets/img/parkit-logo.png" alt="Logo" class="preloader-logo" />
    <p class="preloader-text mt-3">{{ 'loadingGeneric' | loaderText }}<span class="dots">.</span></p>
  </div>
</div>
